<template>
  <div style="border: 1px solid transparent;">
    <div class="password-reset">
      <h1 class="title" style="font-weight:600">新建工单</h1>
      <div class="password-reset-wrap">
        <div class="gongdan_text">
          <p style="font-weight:600">尊敬的用户：</p>
          <p style="margin-left: 26px;">您好！欢迎您使用工单服务，您安装的智能传感采集终端监测到用电线路中存在用电安全及电气火灾隐患，平台发出预警信息，经过</p>
          <p>预处理后，如果安全隐患“未解除”，您可以提交工单，获得专业咨询指导或现场整改服务。</p>
          <el-form ref="form" :model="form">
            <p style="font-weight:600">1、您想获得的服务？（多选）</p>
            <el-form-item prop="contentIds"
                          :rules="{ type: 'array', required: true, message: '请至少选择一个服务', trigger: 'change' }">
              <el-checkbox-group v-model="form.contentIds">
                <el-checkbox v-for="label in checkboxData" :label="label.id" :key="label.id">{{label.name}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <p style="font-weight:600">2、您的问题描述及对我们的要求？</p>
            <el-form-item prop="content" :rules="{ required: true, message: '请填写问题描述或要求', trigger: 'blur' }">
              <textarea style="margin-top: 12px;" v-model="form.content" class="feedcontent" name="feedcontent" id=""
                        cols="30" rows="10" placeholder="请输入您的问题及要求"></textarea>
            </el-form-item>
            <p style="font-weight:600">3、您的联系方式？</p>
            <el-form-item style="margin-top: 24px;" label="负责人：" prop="contact" class="txt_"
                          :rules="{ required: true, message: '请填写负责人', trigger: 'blur' }">
              <el-input v-model="form.contact"></el-input>
            </el-form-item>
            <el-form-item label="联系方式：" prop="contactInformation" class="txt_"
                          :rules="{ required: true, validator: checkPhone, trigger: 'blur' }">
              <el-input v-model="form.contactInformation"></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div class="form-gorup button-group">
          <el-button @click="cancel">取消</el-button>
          <el-button @click="confirm('form')" :loading="loading" type="primary">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkPhone: (rule, value, callback) => {    //手机号验证
        if (!value) {
          return callback(new Error('手机号不能为空'));
        } else {
          const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入正确的手机号'));
          }
        }
      },
      loading: false,
      form: {
        contentIds: [],
        content: '',
        contact: '',
        contactInformation: ''
      },
      checkboxData: [{
        id: '1',
        name: '专职电气顾问服务：' + "\n" +
          '委派专职电气工程师，提供专业咨询、指导、故障处理等专业服务。'
      },
        {
          id: '2',
          name: '24 小时远程值守服务：提供 7*24 小时远程值守服务，一旦报警立即通知到用户。'
        },
        {
          id: '3',
          name: '电气线路隐患排查服务：根据平台报警信息，研判报警原因，对存在的电气线路隐患进行分析定位，提供完整的优化方案。'
        },
        {
          id: '4',
          name: '电气线路整改服务：根据预警数据和用电运行曲线，由专业服务团队进行现场线路整改及优化，从根源上消除隐患，提高用电效能减少用电安全事故。'
        },
        {
          id: '5',
          name: '日常线路巡检服务：定期检查地面可见线路和墙面配电箱体内的接线、紧固线缆接头、清理线缆接点灰尘，并对用电线路进行过载、温度、漏电等检测。'
        }, {
          id: '6',
          name: '其他：（电气火灾预警、智能空开、烟感、可燃气体等智能传感采集终端设备试用；安全知识培训；电气火灾防控演练等）。'
        }
      ],

    }

  },
  mounted() {
    this.$store.commit('updateOutComponentLoading', false)
  },
  methods: {
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http.post('/api/work/add', {
            contact: this.form.contact,
            contactInformation: this.form.contactInformation,
            content: this.form.content,
            contentIds: this.form.contentIds
          }).then(res => {
            this.$message({type: 'success', message: '提交成功'});
            this.$store.commit('fadeOutComponent')
          }).catch(error => {
            this.loading = false;
            this.$message({type: 'error', message: error.msg})
          })
        } else {
          return false;
        }
      });

    },
    cancel() {
      this.$store.commit('fadeOutComponent')
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/component/base-gongdan.vue